/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';

const { api } = vopayApi;

export function useFetchAccountUserPermissions(bearer?: string) {
  const source = axios.CancelToken.source();

  // State
  const [permissions, setPermissions] = useState<vp.PermissionsMap>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function fetchAccountUserPermissions(params: vp.AccountUserPermissionsRequest) {
    try {
      setLoading(true);
      const res = await api.fetchAccountUserPermissionsNew(params, bearer, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      setPermissions(res.Permissions);
      return res;
    } catch (err) {
      setPermissions({});
      console.error(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return {
    permissions,
    loading,
    fetchAccountUserPermissions,
  };
}

// Default export for backward compatibility
export default useFetchAccountUserPermissions;
